import React, { useMemo } from "react";
import PropTypes from "prop-types";
import GenericCard from "components/UI/GenericCard/GenericCard";
import { Column } from "@ant-design/plots";

const YearlyEdgeChart = (props) => {
  const { metrics } = props.optionsResults;

  const data = useMemo(
    () =>
      metrics.yearlyBreakdown.map((y) => ({
        label: `${y.year} (n=${y.count})`,
        successRate: y.successRate,
      })),
    [metrics.yearlyBreakdown],
  );

  const config = {
    data,
    xField: "label",
    yField: "successRate",
    label: { position: "top", formatter: (d) => `${d.successRate}%` },
  };

  return (
    <GenericCard
      title="Year-by-year success rate"
      tooltipText="Is the edge present in every year, or did one year (e.g. an unusually volatile one) carry the whole thing? A durable edge should hold up reasonably across different market regimes, not just one."
      maxHeight={500}
      isCardOpenByDefault={false}
      className="table-card"
    >
      <Column {...config} height={350} autoFit={false} />
    </GenericCard>
  );
};

YearlyEdgeChart.propTypes = { optionsResults: PropTypes.object };

export default YearlyEdgeChart;
